export default "__VITE_PUBLIC_ASSET__8415e617__"